 import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import React, { useEffect } from 'react';
const VoiceSMS = () => { 
    useEffect(() => {
        document.title = 'Voice SMS -  St. Francis Xavier School';  
    }, []);  
  return (
      <>
      <Header/>
      <div className="innerslide">
      <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li> 
          <li>  Gallery</li>
           <li>Voice SMS</li>
      </ul>
  </div> 
            <section className="innerbody">
              <div className='container'>
              <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Republic Day</p>
                      <p><strong>Voice of : </strong> Fr. Jerry Paul Lobo</p>
                      <p><strong>Recorded On : </strong> 20th January 2020</p>
                      <p><strong>Sent to Parents On : </strong> 26th January 2020</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/37_St. Francis Xavier School_Hisar_Fr. Jerry Paul Lobo_Republic Day_2020.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Christmas 2019 & New Year 2020</p>
                      <p><strong>Voice of : </strong> Fr. Jerry Paul Lobo</p>
                      <p><strong>Recorded On : </strong> 20th December 2019</p>
                      <p><strong>Sent to Parents On : </strong> 25th December 2019</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/32_St. Francis Xavier School_Hisar_Fr Jerry Paul Lobo_Christmas2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Diwali 2019</p>
                      <p><strong>Voice of : </strong> Fr. Jerry Paul Lobo</p>
                      <p><strong>Recorded On : </strong> 20th October 2019</p>
                      <p><strong>Sent to Parents On : </strong> 27th October 2019</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/34_St. Francis Xavier School_Hisar_Fr.Jerry Paul Lobo_Diwali_2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> 73rd INDEPENDENCE DAY</p>
                      <p><strong>Voice of : </strong> Fr. Jerry Paul Lobo</p>
                      <p><strong>Recorded On : </strong> 06th August 2019</p>
                      <p><strong>Sent to Parents On : </strong> 15th August 2019</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/44_St. Francis Xavier School_Hisar_Fr. Jerry Paul Lobo_Indepenence Day_2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Easter 2019</p>
                      <p><strong>Voice of : </strong> Fr. Jerry Paul Lobo</p>
                      <p><strong>Recorded On : </strong> 20th April 2019</p>
                      <p><strong>Sent to Parents On : </strong> 21st April 2019</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/15_ST_FRANCIS_XAVIER_SCHOOL_HISAR_FR. Jerry Paul Lobo_Easter_2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Holi</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 20th March 2019</p>
                      <p><strong>Sent to Parents On : </strong> 21st March 2019</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/1_SFXS_HISAR_FR_IVO_R_DIAS_HOLI_2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Republic Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 25th January 2019</p>
                      <p><strong>Sent to Parents On : </strong> 26th January 2019</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/3_St. Francis Xavier School_Hisar_Fr. Ivo R Dias_Republic Day2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Christmas 2018 & New Year Wishes</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 20th December 2018</p>
                      <p><strong>Sent to Parents On : </strong> 25th December 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/6-St.FrancisXavierSchool_Hisar_Fr.IvoRDias_Christmas_New_Year2019.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Children's Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 10th November , 2018</p>
                      <p><strong>Sent to Parents On : </strong> 14th November , 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/3- St. Francis Xavier School_Hisar_Fr. Ivo R Dias_Children Day 2018.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Diwali</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 01st November , 2018</p>
                      <p><strong>Sent to Parents On : </strong> 07th November , 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/3- St. Francis Xavier School_Hisar_Fr. Ivo R Dias_DIWALI 2018.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Gandhi Jayanti</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 26th September, 2018</p>
                      <p><strong>Sent to Parents On : </strong> 02nd October, 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/1- St. Francis Xavier School, Hisar_Fr. Ivo R Dias_Gandhi Jayanti 2018.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Teachers' Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 30th August, 2018</p>
                      <p><strong>Sent to Parents On : </strong> 05th September, 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/9- Fr. Ivo R Dias_St. Francis Xavier School_Hisar_Teachers' Day_2018.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> 72nd Independence Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 08th August, 2018</p>
                      <p><strong>Sent to Parents On : </strong> 15st August, 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/10- St. Francis Xavier School, Hisar_Fr. Ivo R. Dias_15 Aug_2018.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Easter</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 27th March, 2018</p>
                      <p><strong>Sent to Parents On : </strong> 1st April, 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/5- St. Francis Xavier School_Hisar_Fr. Ivo R Dias_2018_Easter.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Holi</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 26th February, 2018</p>
                      <p><strong>Sent to Parents On : </strong> 1st March, 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/8- St. Francis Xavier School, Hisar_Fr. Ivo R Dias_2018_Holi.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Republic Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 22nd January, 2018</p>
                      <p><strong>Sent to Parents On : </strong> 26th January, 2018</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/1- St. Francis Xavier School,Hisar_Fr Ivo R Dias_REPDAY_2018.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Christmas 2017 & New Year Wishes</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 22nd December, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 25 th December, 2017</p>
                      <div className="clr10"></div>
                      <audio src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/cris_2018.mp3" controls
                          preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Diwali 2017</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 12th October, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 19 th October , 2017</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/9- St. Francis Xavier School, Hisar_Fr. Ivo R Dias_Diwali_2017.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Gandhi Jayanti 2017</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 26th September, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 02 nd October , 2017</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/2- St. Francis Xavier School, Hisar_Fr. Ivo R Dias_Gandhi Jayanti 2017 (1).mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Teachers' Day 2017</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 30th August, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 5 th September , 2017</p>
                      <div className="clr10"></div>
                      <audio src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/TeachersDay2017.mp3" controls
                          preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> 71st Independence Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 10th August, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 15 th August, 2017</p>
                      <div className="clr10"></div>
                      <audio src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/Independence_day.mp3" controls
                          preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> EASTER</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 10th April, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 16 th April, 2017</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/1-St.FrancisXavierSchool_Hisar_Fr Ivo RDias_2017_Easter.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Holi</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 8th March, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 12 th March, 2017</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/2- St. Francis Xavier School_Hisar_Fr. Ivo R Dias_Holi_2017.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> 68th Republic Day</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 23rd January, 2017</p>
                      <p><strong>Sent to Parents On : </strong> 26 th January, 2017</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/2- St. Francis Xavier School_Hisar_Fr Ivo R Dias_Republic Day_2017.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Christmas 2016 & New Year Wishes</p>
                      <p><strong>Voice of : </strong> Fr Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 22nd December, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 25 th December, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/Christmas_NewYear_2017.mp3.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Diwali 2016</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 25th October, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 29 th October , 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/3- ST. FRANCIS XAVIER SCHOOL_HISAR_FR IVO R DIAS_DIWALI_2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Gandhi Jayanti</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 30th September, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 02 nd October , 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/2- ST. FRANCIS XAVIER SCHOOL_HISAR_FR IVO R DIAS_GANDHI  JAYANTI_2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Eid ul-Adha</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 10th September, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 13th September, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/11- ST. FRANCIS XAVIER_HISAR_FR IVO R DIAS_EID AL- ADHA-2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Teacher's Day</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 01st September, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 05th September, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/12- St. Francis Xavier_Hisar_Fr Ivo R Dias_Teachers'  Day_2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> 70th Independence Day</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 10th August, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 15th August, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/4- St. Francis Xavier School_Hisar_Fr Ivo R Dias_15 Aug_2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Holi</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 16th March, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 23rd March, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/24- St.Francis Xavier  School_Hisar_Fr.Ivo.r.Dias_Holi_2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> 'Easter 2016'</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 18th March, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 27th March, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/FrancisXavier_Hisar_Fr.Ivo.R.Dias_Easter-2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="voice_msg_sec">
                      <p><strong>Voice SMS : </strong> Republic Day</p>
                      <p><strong>Voice of : </strong> Fr. Ivo R Dias</p>
                      <p><strong>Recorded On : </strong> 20th January, 2016</p>
                      <p><strong>Sent to Parents On : </strong> 25th January, 2016</p>
                      <div className="clr10"></div>
                      <audio
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/audio/64-Stfrancisxavier_Hisar_IVODIAS_REPUBLICDAY_2016.mp3"
                          controls preload></audio>
                  </div>
              </div>
              </div>
               </div> 
            </section>
<Footer/>
      </>
  )
}

export default VoiceSMS
